import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import {isValidState, isValidZip} from '../../helpers/validation';
import TextField from './editableTextField';
import Row from '../Row';
import Col from '../Col';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {countries} from 'helpers/constants';

class AddressInput extends PureComponent {
  static propTypes = {
    edit: PropTypes.bool,
    group: PropTypes.object.isRequired,
    obj: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    country: PropTypes.string,
  };

  render() {
    const {edit, obj, group, onChange} = this.props;
    let {formatMessage} = this.props.intl;

    return <div className='form-group'
                key='address'>
      <label><FormattedMessage id="general.address"/>{edit ?
        <span className='error'
              style={{marginLeft: 2}}>*</span> : null}</label>
      {edit ? <div>
        <TextField dataKey='address1'
                   placeholder={formatMessage({id: 'general.address'})}
                   maxLength='50'
                   value={obj.address1}
                   required={true}
                   className='form-control'
                   group={group}
                   onChange={onChange}
                   editMode={edit}/>
        <div style={{marginBottom: '10px'}}/>
        <TextField placeholder={formatMessage({id: 'address.input.cont.placeholder'})}
                   dataKey='address2'
                   maxLength='50'
                   value={obj.address2}
                   className='form-control'
                   group={group}
                   onChange={onChange}
                   editMode={edit}/>
        <div style={{marginBottom: '10px'}}/>
        <Row style={{margin: 0}}>
          <Col md={6}
               style={{padding: '0 5px 0 0'}}>
            <TextField placeholder={formatMessage({id: 'general.city'})}
                       dataKey='city'
                       maxLength='50'
                       value={obj.city}
                       required={true}
                       className='form-control'
                       group={group}
                       onChange={onChange}
                       editMode={edit}/>
          </Col>
          <Col md={6}
               style={{padding: '0 0 0 5px'}}>
            <TextField placeholder={formatMessage({id: 'general.state'})}
                       dataKey='state'
                       validate={x => isValidState(x, this.props.country)}
                       validateMessage={<FormattedMessage id={this.props.country === countries.CA ? 'form.validation.province' : 'form.validation.state'} />}
                       maxLength='3'
                       value={obj.state}
                       required={true}
                       className='form-control'
                       group={group}
                       onChange={onChange}
                       editMode={edit}/>
          </Col>
        </Row>
        <div style={{marginBottom: '10px'}}/>
        <TextField placeholder={formatMessage({id: 'general.zip'})}
                   dataKey='zip'
                   maxLength='10'
                   validate={x => isValidZip(x, this.props.country)}
                   validateMessage={<FormattedMessage id={this.props.country === countries.CA ? 'form.validation.postal' : 'form.validation.zip'}/>}
                   value={obj.zip}
                   required={true}
                   className='form-control'
                   group={group}
                   onChange={onChange}
                   editMode={edit}/>
      </div> : <div className='form-control-static'>
        <p>{obj.address1}<br/>
          {obj.address2 ? <span>{obj.address2}<br/></span> : null}
          {obj.city}, {obj.state}<br/>
          {obj.zip}</p></div>}
    </div>;

  }
}

export default injectIntl(AddressInput);
